import { db } from "./db.js";

export const ipfsParts = url => {
  let [cId, ...content] = url.replace('ipfs://', '').split('/');
  if (content) {
    content.unshift('');
    content = content.join('/')
  }
  return { cId, content }
}

export const isZeroIndex = async cId => {
  const zero = await ipfsFetch(cId, '/0');
  return !(zero instanceof Blob);
}

export const ipfs2http = async (url, getUrl = false) => {
  const { cId, content } = ipfsParts(url);
  return ipfsFetch(cId, content, getUrl);
}

export const ipfsFetch = async (cId, content, getUrl = false) => {
  if (!getUrl) {
    const stored = await db.ipfsFile.where({ cId, content }).first();
    if (stored) {
      return stored.contents;
    }
  }
  const urls = [
    `https://ipfs.lateralthink.club/ipfs/${ cId }${ content || '' }`,
    `http://localhost:8080/ipfs/${ cId }${ content || '' }`,
    `https://gateway.pinata.cloud/ipfs/${ cId }${ content || '' }`,
    `https://ipfs.io/ipfs/${ cId }${ content || '' }`,
    `https://gateway.ipfs.io/ipfs/${ cId }${ content || '' }`,
    `https://cloudflare-ipfs.com/ipfs/${ cId }${ content || '' }`,
    `https://ipfs.fleek.co/ipfs/${ cId }${ content || '' }`
  ]

  for (const url of urls) {
    try {
      let resp = await fetch(url);
      if (getUrl) {
        return resp.url;
      } else if (resp.headers.get('Content-type') === 'application/json') {
        let result = await resp.json();
        await db.ipfsFile.put({ cId, content, contents: result });
        return result;
      } else {
        return await resp.blob();
      }
    } catch (err) { console.log(err) }
  }

  return null;
}

export const getPins = async (account, type, domain = 'https://ipfs.lateralthink.club') => {
  const opts = { method: 'POST', headers: { 'Content-type': 'application/json', 'lt-account': account } }
  try {
    const resp = await fetch(`${ domain }/api/v0/pin/ls${ type ? `?type=${ type }`: ''}`, opts);
    if (resp.ok) {
      return await resp.json();
    }
  } catch {}
}

export const getIpfsFolder = async (cId, account, domain = 'https://ipfs.lateralthink.club') => {
  const stored = await db.ipfsFolders.where({ Hash: cId }).first();
  if (stored) {
    return stored.Links;
  }
  const opts = { method: 'POST', headers: { 'Content-type': 'application/json', 'lt-account': account } }
  try {
    const resp = await fetch(`${ domain }/api/v0/ls?arg=${ cId }`, opts);
    if (resp.ok) {
      const content = await resp.json();
      await db.ipfsFolders.put(content.Objects[0]);
      return content.Objects[0].Links;
    }
  } catch {}
}

export const uploadIpfsFolder = async (folder, account, domain = 'https://ipfs.lateralthink.club') => {
  const opts = { method: 'POST', headers: { 'lt-account': account }, body: folder }
  const resp = await fetch(`${ domain }/api/v0/add?wrap-with-directory=true&cid-version=1`, opts);
  if (resp.ok) {
    const text = await resp.text();
    const result = [];
    for (const f of text.split('\n')) {
      if (f) {
        result.push(JSON.parse(f))
      }
    }
    return result;
  }
}

export const pin = async (cId, account, domain = 'https://ipfs.lateralthink.club') => {
  const opts = { method: 'POST', headers: { 'lt-account': account } }
  const resp = await fetch(`${ domain }/api/v0/pin/add?arg=${ cId }`, opts);
  if (!resp.ok) throw Error(resp.status);
}

export const unPin = async (cId, account, domain = 'https://ipfs.lateralthink.club') => {
  const opts = { method: 'POST', headers: { 'lt-account': account } }
  const resp = await fetch(`${ domain }/api/v0/pin/rm?arg=${ cId }`, opts);
  if (!resp.ok) throw Error(resp.status);
}